import React from "react";
import { withRouter } from "react-router-dom";

import DesignDetails from "./gazetteDetails/DesignDetails";
import DetailsSection from "./gazetteDetails/DetailsSection";
import PatentDetails from "./gazetteDetails/PatentDetails";
import TrademarkDetails from "./gazetteDetails/TrademarkDetails";
import UMDetails from "./gazetteDetails/UMDetails";

const Details = (props) => {
  const { gazettes, type, content, id } = props;

  return (
    <DetailsSection type={type} details={content.details} count={gazettes.length}>
      {id === "patent" ? <PatentDetails gazettes={gazettes} type={type} content={content} /> : null}
      {id === "um" ? <UMDetails gazettes={gazettes} type={type} content={content} /> : null}
      {id === "trademark" ? (
        <TrademarkDetails gazetteType={id} gazettes={gazettes} type={type} content={content} />
      ) : null}
      {id === "design" ? <DesignDetails gazettes={gazettes} type={type} content={content} /> : null}
    </DetailsSection>
  );
};

export default withRouter(Details);
